import { EntityLookupModel } from "./entity-lookup.model";
import { SearchGlobalModel } from "./search-global.model";

export namespace FlattenWallsWorkerModel {

  export type WorkerMessageType = 'RUN_FLATTEN' | 'RUN_FLATTEN_SUCCESS' | 'RUN_FLATTEN_FAIL';
  type RunWallsFlattenType = Extract<WorkerMessageType, 'RUN_FLATTEN'>;
  type RunWallsFlattenSuccessType = Extract<WorkerMessageType, 'RUN_FLATTEN_SUCCESS'>;
  type RunWallsFlattenFailType = Extract<WorkerMessageType, 'RUN_FLATTEN_FAIL'>;

  export interface RunWallsFlattenMessage {
    type: RunWallsFlattenType;
    requestId: string;
    walls?: any[] //WallV2Model.WallMongoDocument[];
    lookups: EntityLookupModel.EntityLookupMap
  }

  export interface RunWallsFlattenSuccessMessage {
    type: RunWallsFlattenSuccessType;
    requestId: string;
    searchableWalls: SearchGlobalModel.SearchWallDocument[],
  }

  export interface RunWallsFlattenFailMessage {
    type: RunWallsFlattenFailType;
    requestId: string;
    error: any;
  }

  export function isRunWallsFlattenSuccessMessage(
    msg: FlattenWorkerMessage
  ): msg is RunWallsFlattenSuccessMessage {
    return msg.type === 'RUN_FLATTEN_SUCCESS';
  }

  export function isRunWallsFlattenFailMessage(
    msg: FlattenWorkerMessage
  ): msg is RunWallsFlattenFailMessage {
    return msg.type === 'RUN_FLATTEN_FAIL';
  }


  export type FlattenWorkerMessage =
    | RunWallsFlattenMessage
    | RunWallsFlattenSuccessMessage
    | RunWallsFlattenFailMessage;


}


